import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import SignUpPage from './components/SignUpPage';
import SignInPage from './components/SignInPage';
import LandingPage from './components/LandingPage';
import ListingPage from './components/ListingPage';
import Form from './components/Form';

const theme = createTheme({
  // Your theme configuration
});

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/signin');
    }
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsAuthenticated(!!token);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
        <Routes>
          <Route 
            path="/signup" 
            element={
              isAuthenticated ? 
                <Navigate to="/listing" /> : 
                <SignUpPage setIsAuthenticated={setIsAuthenticated} />
            } 
          />
          <Route 
            path="/signin" 
            element={
              isAuthenticated ? 
                <Navigate to="/listing" /> : 
                <SignInPage setIsAuthenticated={setIsAuthenticated} />
            } 
          />
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Navigate to="/listing" />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/landing" 
            element={
              <ProtectedRoute>
                <LandingPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/listing" 
            element={
              <ProtectedRoute>
                <ListingPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/form/:participantId" 
            element={
              <ProtectedRoute>
                <Form />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
